import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, Link, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
import { FaAngleLeft } from "react-icons/fa";
import ImgChangeIcon from "../../../../assets/images/camera-icon.png";
import Sidebar from "../../../../components/sidebar/Sidebar";
import Navbar from "../../../../components/navbar/Navbar";
import Loader from "../../../../components/Loader/Loader";
import "../../../new/new.scss";
import Select from "react-select";

const Addteam = () => {
  const [file, setFile] = useState({
    files: "",
    preview:
      "https://icon-library.com/images/no-image-icon/no-image-icon-0.jpg",
  });
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [countryId, setCountryID] = useState([]);
  const [data, setData] = useState([]);
  const {
    register,
    handleSubmit,

    formState: { errors },
  } = useForm({
    mode: "all",
  });
  const handleCountry = (e) => {
    // const getCounryId = e.target.value;
    // setCountryID(getCounryId);
    setCountryID(Array.isArray(e) ? e.map((x) => x.value) : []);
  };

  useEffect(() => {
    getCountry();
  }, []);
  const getCountry = async () => {
    const res = await axios({
      method: "GET",
      url: process.env.REACT_APP_API + "get-country",
    });

    const data = res?.data?.data;
    const options = data?.map((d) => ({
      value: d?.id,
      label: d?.country_name,
    }));
    setData(options);
  };

  const profileImage = (e) => {
    const selected = e.target.files[0];
    const ALLOWED_TYPES = ["image/png", "image/jpeg", "image/jpg"];
    if (selected && ALLOWED_TYPES.includes(selected.type)) {
      setError(false);
      setFile({
        files: e.target.files[0],
        preview: URL.createObjectURL(e.target.files[0]),
      });
    } else {
      setError(true);
    }
  };

  const onSubmit = async (data) => {
    const token = localStorage.getItem("accessToken");
    setLoading(true);
    let formData = new FormData();
    for (let dataKey in data) {
      if (dataKey === "preview") {
        for (let previewKey in data[dataKey]) {
          formData.append(`preview[${previewKey}]`, data[dataKey][previewKey]);
        }
      } else {
        formData.append(dataKey, data[dataKey]);
      }
    }
    formData.append("file", file?.files);
    formData.append("country_id", JSON.stringify(countryId));
    try {
      const res = await axios({
        method: "POST",
        url: process.env.REACT_APP_API + "admin/save-our-team",
        data: formData,

        headers: {
          "Content-Type": "multipart/form-data",
          "x-access-token": token,
        },
      });

      if (res.data.status === 200) {
        setLoading(false);
        Swal.fire({
          title: "Success",
          timer: 2500,
          timerProgressBar: true,
          text: res.data.message,
          icon: "success",
          confirmButtonText: "OK",
          showCloseButton: true,
        });
        navigate("/our-teams");
      }
    } catch (error) {
      setLoading(false);
      if (error.response !== "" && error.response.data.message !== "") {
        Swal.fire({
          title: "Error",
          timer: 2500,
          timerProgressBar: true,
          text: error.response.data.message,
          icon: "error",
          confirmButtonColor: "#f27474",
          confirmButtonText: "OK",
          dangerMode: true,
          showCloseButton: true,
        });
      }
    }
  };

  return (
    <div className="new">
      <Loader isLoading={loading} />
      <Sidebar />
      <div className="newContainer">
        <Navbar />
        <div className="top">
          <span className="backarrow">
            <FaAngleLeft onClick={() => navigate(-1)} />
          </span>
          <h1 className="view-page-tittle">Add New Team</h1>
        </div>
        <div className="bottom">
          <div className="left">
            <div className="profile-pic-div">
              <div className="imgChange-div">
                <img src={ImgChangeIcon} alt="" className="imgChangeIcon" />
              </div>
              <input
                type="file"
                name="file"
                accept="image/png , image/jpeg"
                title=""
                className="profile-pic-select"
                onChange={(e) => profileImage(e)}
              />

              <img
                src={
                  file
                    ? file.preview
                    : "https://icon-library.com/images/no-image-icon/no-image-icon-0.jpg"
                }
                alt=""
                className="setting-profile"
              />
            </div>

            {error && (
              <span style={{ color: "red" }}>
                Please upload file in jpg,jpeg and png format
              </span>
            )}
          </div>
          <div className="right">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="formInput">
                <label>First Name</label>
                <input
                  type="text"
                  name="firstname"
                  {...register("firstname", {
                    required: "First name is required",
                    pattern: {
                      value: /^[a-zA-Z._ ]*$/,
                      message: "Please enter only characters",
                    },
                  })}
                  placeholder="Enter First Name"
                />
                {errors.firstname && (
                  <div className="invalid-feedback">
                    {errors.firstname.message}
                  </div>
                )}
              </div>
              <div className="formInput">
                <label>Last Name</label>
                <input
                  type="text"
                  name="lastname"
                  {...register("lastname", {
                    required: "Last name is required",
                    pattern: {
                      value: /^[a-zA-Z_ ]*$/,
                      message: "Please enter only characters",
                    },
                  })}
                  placeholder="Enter Last Name"
                />
                {errors.lastname && (
                  <div className="invalid-feedback">
                    {errors.lastname.message}
                  </div>
                )}
              </div>

              <div className="formInput">
                <label>Designation</label>
                <input
                  type="text"
                  name="profile_designation"
                  {...register("profile_designation", {
                    required: "Designation is required",
                    // pattern: {
                    //   value: /^[a-zA-Z_ ]*$/,
                    //   message: "Please enter only characters",
                    // },
                  })}
                  placeholder="Enter Designation"
                />
                {errors.profile_designation && (
                  <div className="invalid-feedback">
                    {errors.profile_designation.message}
                  </div>
                )}
              </div>
              <div className="formInput">
                <label>Country</label>

                <Select
                  className="sort-by dropdown country-drp"
                  isMulti={true}
                  options={data}
                  value={countryId?.map(
                    (id) => data?.filter((d) => d.value == id)[0]
                  )}
                  onChange={handleCountry}
                />
              </div>
              <div className="formInput">
                <label>Gmail Link</label>
                <input
                  type="email"
                  name="gmail_handle"
                  {...register("gmail_handle")}
                  placeholder="Enter Email"
                />
                {errors.gmail_handle && (
                  <div className="invalid-feedback">
                    {errors.gmail_handle.message}
                  </div>
                )}
              </div>

              <div className="formInput">
                <label>Role</label>
                <select name="role" {...register("role")}>
                  <option value="" disabled selected hidden>
                    Select
                  </option>
                  <option value="Executive Leaders">Executive Leaders</option>
                  <option value="Board Members">Board members</option>
                  <option value="Management">Management</option>
                  <option value="Consultant">Consultants</option>
                </select>
              </div>

              <div className="formInput">
                <label>Facebook Link</label>
                <input
                  type="text"
                  name="facebook_handle"
                  {...register("facebook_handle")}
                  placeholder="Enter Facebook Link "
                />
                {errors.facebook_handle && (
                  <div className="invalid-feedback">
                    {errors.facebook_handle.message}
                  </div>
                )}
              </div>
              <div className="formInput">
                <label>LinkedIn Link</label>
                <input
                  type="text"
                  name="linkdin_handle"
                  {...register("linkdin_handle")}
                  placeholder="Enter Linkedin Link "
                />
                {errors.linkdin_handle && (
                  <div className="invalid-feedback">
                    {errors.linkdin_handle.message}
                  </div>
                )}
              </div>

              <div className="formInput">
                <label>Education</label>
                <input
                  type="text"
                  name="education"
                  {...register("education")}
                  placeholder="Enter Education"
                />
                {errors.education && (
                  <div className="invalid-feedback">
                    {errors.education.message}
                  </div>
                )}
              </div>
              <div className="formInput">
                <label>Display Order</label>
                <input
                  type="number"
                  name="order_no"
                  {...register("order_no", {
                    required: "Order No is required",
                    min: 0,
                    // pattern: /^[0-9]+$/,
                  })}
                  placeholder="Enter Order No"
                />
                {errors.order_no && (
                  <div className="invalid-feedback">
                    {errors.order_no.message}
                  </div>
                )}
              </div>
              <div className="formInput">
                <label>English Description</label>

                <textarea
                  type="text"
                  name="en_profile"
                  className="description-textarea"
                  {...register("en_profile", {
                    required: "Description is required",
                  })}
                  cols="47"
                  rows="5"
                  placeholder="Enter Bio"
                ></textarea>
                {errors.en_profile && (
                  <div className="invalid-feedback text-left">
                    {errors.en_profile.message}
                  </div>
                )}
              </div>
              <div className="formInput">
                <label>Italian Description</label>

                <textarea
                  type="text"
                  name="it_profile"
                  className="description-textarea"
                  {...register("it_profile", {
                    required: "Description is required",
                  })}
                  cols="47"
                  rows="5"
                  placeholder="Enter Bio"
                ></textarea>
                {errors.it_profile && (
                  <div className="invalid-feedback text-left">
                    {errors.it_profile.message}
                  </div>
                )}
              </div>
              <div className="formInput">
                <label>French Description</label>

                <textarea
                  type="text"
                  name="fr_profile"
                  className="description-textarea"
                  {...register("fr_profile", {
                    required: "Description is required",
                  })}
                  cols="47"
                  rows="5"
                  placeholder="Enter Bio"
                ></textarea>
                {errors.fr_profile && (
                  <div className="invalid-feedback text-left">
                    {errors.fr_profile.message}
                  </div>
                )}
              </div>
              <div className="formInput">
                <label>Spanish Description</label>

                <textarea
                  type="text"
                  name="es_profile"
                  className="description-textarea"
                  {...register("es_profile", {
                    required: "Description is required",
                  })}
                  cols="47"
                  rows="5"
                  placeholder="Enter Bio"
                ></textarea>
                {errors.es_profile && (
                  <div className="invalid-feedback text-left">
                    {errors.es_profile.message}
                  </div>
                )}
              </div>
              <div className="formInput">
                <label>Polish Description</label>

                <textarea
                  type="text"
                  name="pl_profile"
                  className="description-textarea"
                  {...register("pl_profile", {
                    required: "Description is required",
                  })}
                  cols="47"
                  rows="5"
                  placeholder="Enter Bio"
                ></textarea>
                {errors.pl_profile && (
                  <div className="invalid-feedback text-left">
                    {errors.pl_profile.message}
                  </div>
                )}
              </div>
              <div className="formInput"></div>
              <button className="submitBtn">Save</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Addteam;
